import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "recycle",
  "use": "recycle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"recycle\"><defs><style>#recycle .cls-1{fill:none}</style></defs><title>资源 55</title><g id=\"recycle_图层_2\" data-name=\"图层 2\"><g id=\"recycle_图层_1-2\" data-name=\"图层 1\"><path id=\"recycle_Rectangle_48_Copy_13\" data-name=\"Rectangle 48 Copy 13\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"recycle_delete\"><path id=\"recycle_Shape\" d=\"M4.71 22.43a1.65 1.65 0 0 1-1.65-1.65V6.2h-.74a.85.85 0 0 1-.79-.89.86.86 0 0 1 .79-.79h4.34V3.17a1.65 1.65 0 0 1 1.65-1.65h7.38a1.65 1.65 0 0 1 1.65 1.65v1.35h4.32a.9.9 0 0 1 .62.25.87.87 0 0 1 .24.59.86.86 0 0 1-.86.84h-.48v14.58a1.65 1.65 0 0 1-1.65 1.65zm0-1.65h14.81V6.2H4.71zm3.6-16.25h7.37V3.18H8.31zm7.35 13.14V9.85a.85.85 0 1 1 1.69 0v7.82a.85.85 0 0 1-1.69 0zm-4.51 0V9.85a.84.84 0 1 1 1.68 0v7.82a.84.84 0 0 1-1.68 0zm-4.57 0V9.85a.85.85 0 1 1 1.69 0v7.82a.85.85 0 0 1-1.69 0z\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/recycle.svg
// module id = palW
// module chunks = 6